/**
 * HRDocumentsModal — wraps EmployeeHRDocs in a self-service Dialog.
 *
 * Launched from the Profile modal so staff can manage their own
 * driver's license, NJ professional license, certifications, and
 * training certificates without leaving the app.
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { FileText } from 'lucide-react';
import EmployeeHRDocs from './EmployeeHRDocs';

export default function HRDocumentsModal({ open, onClose, token, currentUserId }) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent
        className="sm:max-w-4xl max-h-[92vh] overflow-y-auto"
        data-testid="hr-documents-modal"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-indigo-600" />
            My HR Documents
          </DialogTitle>
          <DialogDescription>
            Upload and manage your employment documents — driver&apos;s license,
            NJ professional license, certifications, and completed trainings.
            All files are stored encrypted at rest.
          </DialogDescription>
        </DialogHeader>
        <EmployeeHRDocs
          token={token}
          currentUserId={currentUserId}
          canVerify={false}
        />
      </DialogContent>
    </Dialog>
  );
}
